
import React from 'react';

export default function CommercialShowcase() {
  const projects = [
    {
      title: 'Sandton Executive Office',
      scope: 'Full office renovation with custom boardroom and reception',
      duration: '8 weeks',
      image:
        'https://public.readdy.ai/ai/img_res/588e095781bbfaf98aebcb9eb02d9092.jpg',
    },
    {
      title: 'Rosebank Boutique Restaurant',
      scope: 'Complete restaurant build-out with commercial kitchen',
      duration: '12 weeks',
      image:
        'https://readdy.ai/api/search-image?query=luxury%20modern%20restaurant%20interior%20elegant%20dining%20area%20contemporary%20design%20warm%20ambient%20lighting%20premium%20finishes%20exposed%20brick%20accent%20wall%20sophisticated%20bar%20area%20comfortable%20seating%20upscale%20hospitality%20venue%20beautiful%20atmosphere&width=700&height=500&seq=comm-show-002&orientation=landscape',
    },
    {
      title: 'Midrand Retail Flagship',
      scope: 'Premium retail fit-out with custom display systems',
      duration: '6 weeks',
      image:
        'https://readdy.ai/api/search-image?query=luxury%20modern%20retail%20store%20interior%20premium%20display%20fixtures%20contemporary%20design%20sophisticated%20lighting%20marble%20flooring%20custom%20shelving%20elegant%20shopping%20environment%20high%20end%20boutique%20beautiful%20visual%20merchandising%20warm%20tones&width=700&height=500&seq=comm-show-003&orientation=landscape',
    },
  ];

  /** Fallback image in case the external service fails */
  const handleImageError = (e) => {
    e.target.src = '/fallback-image.jpg'; // ensure this image exists in the public folder
    e.target.onerror = null; // prevent infinite loop if fallback also fails
  };

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Portfolio
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
            Featured{' '}
            <span className="font-serif text-[#D4AF37]">Commercial Projects</span>
          </h2>
        </div>

        <div className="space-y-10 md:space-y-12">
          {projects.map((project, index) => (
            <article
              key={index}
              className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center"
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : 'lg:order-1'}>
                <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-xl">
                  <div className="w-full h-[240px] sm:h-[300px] md:h-[360px]">
                    <img
                      src={project.image}
                      alt={`${project.title} - Commercial Construction Johannesburg`}
                      title={`${project.title} commercial renovation`}
                      onError={handleImageError}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>

              <div
                className={`space-y-4 md:space-y-6 ${
                  index % 2 === 1 ? 'lg:order-1' : 'lg:order-2'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
                  <span className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase">
                    Project {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="text-2xl md:text-3xl font-bold text-[#2A2A2A]">
                  {project.title}
                </h3>

                <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                  {project.scope}
                </p>

                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-time-line text-[#D4AF37]"></i>
                  <span>Completed in {project.duration}</span>
                </div>

                <a
                  href="/#contact"
                  className="inline-flex items-center gap-2 px-6 md:px-8 py-3 bg-[#D4AF37] text-white text-sm font-semibold rounded-full hover:bg-[#B8941F] transition-all whitespace-nowrap cursor-pointer"
                >
                  Discuss Your Project
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
